import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// 导入模块文件
import module1 from './modules/module1';

const store = new Vuex.Store({
  modules: {
    module1,
  }
});

export default store;
